__turbopack_context__.v({
  "caption": "b4Eq8a_caption",
  "content": "b4Eq8a_content",
  "description": "b4Eq8a_description",
  "directions": "b4Eq8a_directions",
  "imgContainer": "b4Eq8a_imgContainer",
  "root": "b4Eq8a_root",
});
